import React from 'react';
import { MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import Logo from '../components/Logo';

const Login = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/traveler-dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F5F5F7] to-white flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-[0_20px_50px_rgb(0,0,0,0.1)] p-8" data-testid="login-container">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <Logo variant="icon" size="xl" />
          </div>
          <h1 
            className="text-3xl font-bold text-[#4A4A4A] mb-2"
            style={{fontFamily: 'Playfair Display, serif'}}
            data-testid="login-title"
          >
            Welcome to GoHimalayan
          </h1>
          <p className="text-[#4A4A4A]/70">Sign in to start your Himalayan adventure</p>
        </div>

        <Button
          onClick={handleGoogleLogin}
          className="w-full rounded-full bg-[#8B2E2E] hover:bg-[#6B1E1E] text-white py-6 text-lg font-medium btn-primary"
          data-testid="google-login-btn"
        >
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </Button>

        <p className="text-center text-sm text-[#4A4A4A]/60 mt-6">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default Login;
